import React from 'react';

import './NavItem.scss';
import { useLocation, useNavigate } from 'react-router-dom';

const NavItem = ({ to, name, icon, onClick: _onClick }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = !_onClick && (location.pathname === to || location.pathname.includes(name.toLowerCase()));
  const handleClick = () => {
    navigate(to);
  };

  return (
    <div className={`nav-item ${isActive ? 'active' : ''}`} onClick={_onClick ? _onClick : handleClick}>
      <div className="nav-icon-wrapper">
        <div className="nav-icon-bg">
          <img alt={name} className="nav-icon" src={icon} />
        </div>
      </div>
      <p className="nav-name">{name}</p>
    </div>
  );
};

export default NavItem;
